import {disclaimers} from './country-consts'

export function makeSeoHeading(zoneName?: string, tariff?: string, countryCode?: string): string {
  if (countryCode === 'rus') {
    return zoneName ? `page.h1.${zoneName}.${tariff}` : `page.h1.${tariff}`
  }
  return 'order.footer.h1'
}

export function getDisclaimer(deviceVendor: string, deviceOS: string): string {
  if (deviceVendor === 'Huawei') {
    return disclaimers.appGallery
  }
  if (deviceVendor === 'Apple' || deviceOS === 'iOS') {
    return disclaimers.appStore
  }
  return disclaimers.googlePlay
}
